import { apiClient } from "../../../api/client";
import * as ActionType from "./reportReason.type";
import { setToast } from "../../../util/toast";

export const getReportReason = () => async (dispatch) => {
  const res = await apiClient.get("reportReason/getReportReason");
  if (res.ok) {
    dispatch({ type: ActionType.GET_REPORT_REASON, payload: res.data?.reportReason });
  } else {
    console.log(res.message);
  }
};

export const createReportReason = (data) => async (dispatch) => {
  const res = await apiClient.post("reportReason/createReportReason", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_REPORT_REASON, payload: res.data?.reportReason });
    setToast("success", "Report reason created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updateReportReason = (data) => async (dispatch) => {
  const res = await apiClient.patch("reportReason/updateReportReason", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_REPORT_REASON, payload: res.data?.reportReason });
    setToast("success", "Report reason updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const deleteReportReason = (id) => async (dispatch) => {
  const res = await apiClient.delete(`reportReason/deleteReportReason?reportReasonId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_REPORT_REASON, payload: id });
    setToast("success", "Report reason deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
